module.exports = __webpack_public_path__ + "img/Colombia.c3fd30fa.svg";